import PrivacyBanner from './PrivacyBanner.component';

export default PrivacyBanner;
